import { getModuleComponentWithErrorBoundary } from 'layout/module-load/module-build.js';
import { DisplayLoading } from 'layout/module-load/module-load-state.js';
import * as React from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { IDataUrlProps } from './dataUrl-main.js';
import { REMOVE_MODULE_NAME } from './dataUrlHook.js';

export type RenderSuspenseComponentType = (a: IModule & IDataUrlProps) => JSX.Element | null;

/**
 * Used to render module and corresponding config when lazy loading
 * Used by dataUrl when getting additional data
 */
export function RenderSuspenseComponent({
  config,
  isDrawer,
  modulePath,
  debug,
  childModuleName,
  children: ChildComponent,
}: IModule & IDataUrlProps) {
  if (debug) {
    return <div style={{ background: 'green', height: '100px', width: '100%' }}>{`Module Name: ${config.name}`}</div>;
  } else if (config.hideModule || config.name === REMOVE_MODULE_NAME) {
    return null;
  } else if (config.name && config.name !== childModuleName) {
    /** When fetching dataUrl result props can have a different module name so use this instead, this is a legitimate requirement */
    const NewPropsComponent = getModuleComponentWithErrorBoundary(config.name);

    if (NewPropsComponent) {
      return (
        <React.Suspense fallback={<DisplayLoading moduleName={config.name} isMobile={isDrawer ?? false} />}>
          <NewPropsComponent key={`${config.name}`} config={config} isDrawer={isDrawer} modulePath={modulePath} />
        </React.Suspense>
      );
    }
  }

  return (
    <React.Suspense fallback={<DisplayLoading moduleName={config.name} isMobile={isDrawer ?? false} />}>
      <ChildComponent key={`${config.name}`} config={config} isDrawer={isDrawer} modulePath={modulePath} />
    </React.Suspense>
  );
}
